
import Hero from './components/Hero';
import TrustBadges from './components/TrustBadges';
import ProductShowcase from './components/ProductShowcase';
import Features from './components/Features';
import Workflow from './components/Workflow';
import Benefits from './components/Benefits';
import Reasons from './components/Reasons';
import Testimonial from './components/Testimonial';
import Stats from './components/Stats';
import FAQ from './components/FAQ';
import DemoForm from './components/DemoForm';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <TrustBadges />
      <ProductShowcase />
      <Features />
      <Workflow />
      <Benefits />
      <Reasons />
      <Testimonial />
      <Stats />
      <FAQ />
      <DemoForm />
      <FinalCTA />
      <Footer />
    </div>
  );
}
